import PropTypes from "prop-types";
import {useEffect, useState} from "react";

import {getAirportDetails} from "../assets/virtual-flyout/airport-service"

FlyoutRefuel.propTypes = {
  refuel: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  onDelete: PropTypes.func
}

function validate(data) {
  const errors = [];
  if (!data.fuelQty) {
    errors.push("Please enter refuel quantity");
  }
  if (data.fuelQty < 0) {
    errors.push("Refuel quantity cannot be negative");
  }
  return errors;
}

export default function FlyoutRefuel({refuel, index, onChange, onDelete}) {
  const [state, setState] = useState();
  const isEditing = state !== "VIEW";
  const [unsavedData, setUnsavedData] = useState(refuel);

  useEffect(() => {
    setUnsavedData({...refuel, state: "VIEW"});
    setState(refuel.state ?? "VIEW");
  }, [refuel]);

  const [errors, setErrors] = useState();
  useEffect(() => {
    if (state === "INVALID") {
      setErrors(validate(unsavedData));
    }
  }, [unsavedData, state]);

  function handleEdit() {
    setUnsavedData(JSON.parse(JSON.stringify(refuel)));
    setState("EDIT");
  }

  function handleSave() {
    const errors = validate(unsavedData);
    if (!errors || errors.length === 0) {
      onChange(index, unsavedData);
      setState("VIEW");
    } else {
      setState("INVALID");
    }
  }

  function handleDiscard() {
    if (refuel.state === "NEW") {
      handleDelete();
    } else {
      setState("VIEW");
    }
  }

  function handleDelete() {
    onDelete(index);
  }

  function formatLocation(location) {
    if (!location) {
      return '';
    }
    const airport = getAirportDetails(location);
    return airport ? airport.airport_name : location;
  }

  return <div key={index} className="flyout-plan-leg">
    <div className="flyout-plan-leg-header">
      <div className="flyout-plan-refuel-location">
        <h3>Refuel at {formatLocation(refuel.location.code)}</h3>
      </div>
      <div className="flyout-plan-leg-buttons">
        {!isEditing &&
          <button className="flyout-plan-leg-header-button" title="Edit" tabIndex="-1"
                  onClick={handleEdit}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                 stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round"
                    d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"/>
            </svg>
          </button>
        }
        {!isEditing &&
          <button className="flyout-plan-leg-header-button" title="Delete" tabIndex="-1"
                  onClick={handleDelete}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                 stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round"
                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"/>
            </svg>
          </button>
        }
        {isEditing &&
          <button className="flyout-plan-leg-header-button" title="Save" tabIndex="-1" onClick={handleSave}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                 stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5"/>
            </svg>
          </button>
        }
        {isEditing &&
          <button className="flyout-plan-leg-header-button" title="Cancel" tabIndex="-1" onClick={handleDiscard}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                 stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round"
                    d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636"/>
            </svg>
          </button>
        }
      </div>
    </div>
    <div className="flyout-plan-refuel-details">
      <p>to</p>
      {!isEditing && <p>{refuel.fuelQty}</p>}
      {isEditing && <input type="number" step="1" tabIndex="0"
                           className={`flyout-plan-leg-textbox small ${!unsavedData.fuelQty && errors ?
                             'error' : ''}`}
                           value={unsavedData.fuelQty} autoFocus="autofocus"
                           onChange={(e) => setUnsavedData(
                             (prev) => ({...prev, fuelQty: e.target.value}))}/>}
      <p>{refuel.fuelUnit}</p>
    </div>
    {errors && errors.length > 0  && <div className="flyout-plan-leg-errors">
      {errors.map((error, index) => (
        <li key={index}>{error}</li>
      ))}
    </div>}
  </div>
}